import { useEffect, useRef } from 'react'

export interface IPageTitleProps {
  title: string
}
const PageTitle = (props: IPageTitleProps) => {
  const mountedRef = useRef(false)
  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      document.title = props.title
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  return <></>
}

export default PageTitle
